import "../shared/codeload.js";

window.Sparkle ??= {};

window.Sparkle = window.Sparkle || {};
window.Sparkle.Locations = {
  showLocationBrowser() {
    return jQuery.when().then(() => new Sparkle.LocationBrowser("#location-browser-container"));
  },
};
